import LandingView from 'rebook/apps/landing/views/LandingView';
import UserSettingsView from 'rebook/apps/users/views/UserSettingsView';
import PaymentListView from 'rebook/apps/users/views/PaymentListView';
import BookDetailView from 'rebook/apps/books/views/BookDetailView';
import BookBuyRentView from 'rebook/apps/books/views/BookBuyRentView';
import BookFragmentView from 'rebook/apps/books/views/BookFragmentView';
import BooksetDetailView from 'rebook/apps/catalog/views/BooksetDetailView';
import BooksetListView from 'rebook/apps/catalog/views/BooksetListView';
import CatalogIndexView from 'rebook/apps/catalog/views/CatalogIndexView';
import CatalogFreeIndexView from 'rebook/apps/catalog/views/CatalogFreeIndexView';
import CatalogBookListView from 'rebook/apps/catalog/views/CatalogBookListView';
import ActorAudiobookListView from 'rebook/apps/catalog/views/ActorAudiobookListView';
import AuthorDetailView from 'rebook/apps/catalog/views/AuthorDetailView';
import AuthorListView from 'rebook/apps/catalog/views/AuthorListView';
import AuthorBookListView from 'rebook/apps/catalog/views/AuthorBookListView';
import AuthorReviewListView from 'rebook/apps/catalog/views/AuthorReviewListView';
import AuthorCitationListView from 'rebook/apps/catalog/views/AuthorCitationListView';
import DashboardView from 'rebook/apps/dashboard/views/DashboardView';
import Error404View from 'rebook/apps/base/views/Error404View';
import GenreDetailView from 'rebook/apps/catalog/views/GenreDetailView';
import NicheBookListView from 'rebook/apps/catalog/views/NicheBookListView';
import NicheDetailView from 'rebook/apps/catalog/views/NicheDetailView';
import UserProfileView from 'rebook/apps/users/views/UserProfileView';
import UserAllBooksView from 'rebook/apps/users/views/UserAllBooksView';
import UserReadBooksView from 'rebook/apps/users/views/UserReadBooksView';
import UserReadingBooksView from 'rebook/apps/users/views/UserReadingBooksView';
import UserBookshelvesView from 'rebook/apps/users/views/UserBookshelvesView';
import UserBookmarkView from 'rebook/apps/users/views/UserBookmarkView';
import BookshelfDetailView from 'rebook/apps/catalog/views/BookshelfDetailView';
import BookshelfEditView from 'rebook/apps/users/views/BookshelfEditView';
import UserWishlistBooksView from 'rebook/apps/users/views/UserWishlistBooksView';
import UserUploadedBooksView from 'rebook/apps/users/views/UserUploadedBooksView';
import ResetPasswordView from 'rebook/apps/users/views/ResetPasswordView';
import RightholderBooksView from 'rebook/apps/catalog/views/RightholderBooksView';
import SetNewPasswordView from 'rebook/apps/users/views/SetNewPasswordView';
import SeriesDetailView from 'rebook/apps/catalog/views/SeriesDetailView';
import TagListView from 'rebook/apps/catalog/views/TagListView';
import TagDetailView from 'rebook/apps/catalog/views/TagDetailView';
import SearchResultView from 'rebook/apps/search/views/SearchResultView';
import StaticPageView from 'rebook/apps/pages/views/StaticPageView';
import GiftCodeView from 'rebook/apps/payments/views/GiftCodeView';
import PaymentsView from 'rebook/apps/payments/views/PaymentsView';
import PaymentStatusView from 'rebook/apps/payments/views/PaymentStatusView';
import PaymentRentStatusView from 'rebook/apps/payments/views/PaymentRentStatusView';
import UserSubscriptionListView from 'rebook/apps/users/views/UserSubscriptionListView';
import FaqIndexView from 'rebook/apps/faq/views/FaqIndexView';
import FaqQuestionView from 'rebook/apps/faq/views/FaqQuestionView';
import LoginView from 'rebook/apps/account/views/LoginView';
import UnsubscribeView from 'rebook/apps/account/views/UnsubscribeView';
import BookReviewListView from 'rebook/apps/books/views/BookReviewListView';
import BookReviewPageView from 'rebook/apps/books/views/BookReviewPageView';
import BookCitationListView from 'rebook/apps/books/views/BookCitationListView';
import BookCitationPageView from 'rebook/apps/books/views/BookCitationPageView';
import WeekTrialView from 'rebook/apps/trial/views/WeekTrialView';
import BookAuthorListView from 'rebook/apps/books/views/BookAuthorListView';
import BookPaymentsView from 'rebook/apps/books/views/BookPaymentsView';
import SearchBooksView from 'rebook/apps/search/views/SearchBooksView';
import SearchAudioBooksView from 'rebook/apps/search/views/SearchAudioBooksView';
import SearchSeriesView from 'rebook/apps/search/views/SearchSeriesView';
import SearchGenresThemesView from 'rebook/apps/search/views/SearchGenresThemesView';
import SearchRightholdersView from 'rebook/apps/search/views/SearchRightholdersView';
import SimilarBooksView from 'rebook/apps/books/views/SimilarBooksView';
import SearchAuthorsView from 'rebook/apps/search/views/SearchAuthorsView';
import SearchBooksetsView from 'rebook/apps/search/views/SearchBooksetsView';
import SearchByPreferencesView from 'rebook/apps/searchByPreferences/views/SearchByPreferencesView';
import OfferView from 'rebook/apps/offer/views/OfferView';


const routes = [
  {
    path: '/',
    exact: true,
    component: LandingView,
  },
  {
    path: '/about/',
    exact: true,
    component: StaticPageView,
  },
  {
    path: '/about/:page/',
    exact: true,
    component: StaticPageView,
  },
  {
    path: '/account/edit/',
    exact: true,
    component: UserSettingsView,
  },
  {
    path: '/account/login/',
    exact: true,
    component: LoginView,
  },
  {
    path: '/account/payments/',
    exact: true,
    component: PaymentListView,
  },
  {
    path: '/account/reset-password/',
    exact: true,
    component: ResetPasswordView,
  },
  {
    path: '/account/set-password/',
    exact: true,
    component: SetNewPasswordView,
  },
  {
    path: '/account/subscriptions/',
    exact: true,
    component: UserSubscriptionListView,
  },
  {
    path: '/account/unsubscribe/',
    exact: true,
    component: UnsubscribeView,
  },
  {
    path: '/account/unsubscribe-new/',
    exact: true,
    component: UnsubscribeView,
  },
  {
    path: '/actor/:actorSlug/',
    exact: true,
    component: ActorAudiobookListView,
  },
  {
    path: '/author/:authorSlug/',
    exact: true,
    component: AuthorDetailView,
  },
  {
    path: '/author/:authorSlug/books/',
    exact: true,
    component: AuthorBookListView,
  },
  {
    path: '/author/:authorSlug/books/:bookType/',
    exact: true,
    component: AuthorBookListView,
  },
  {
    path: '/author/:authorSlug/citations/',
    exact: true,
    component: AuthorCitationListView,
  },
  {
    path: '/author/:authorSlug/reviews/',
    exact: true,
    component: AuthorReviewListView,
  },
  {
    path: '/author/:authorSlug/:bookSlug/buy_rent/',
    exact: true,
    component: BookBuyRentView,
  },
  {
    path: '/author/:authorSlug/:bookSlug/',
    exact: true,
    component: BookDetailView,
  },
  {
    path: '/author/:authorSlug/:bookSlug/authors/',
    exact: true,
    component: BookAuthorListView,
  },
  {
    path: '/author/:authorSlug/:bookSlug/payments/',
    exact: true,
    component: BookPaymentsView,
  },
  {
    path: '/author/:authorSlug/:bookSlug/reviews/',
    exact: true,
    component: BookReviewListView,
  },
  {
    path: '/author/:authorSlug/:bookSlug/reviews/:reviewId/',
    exact: true,
    component: BookReviewPageView,
  },
  {
    path: '/author/:authorSlug/:bookSlug/citations/',
    exact: true,
    component: BookCitationListView,
  },
  {
    path: '/author/:authorSlug/:bookSlug/citations/:citationId/',
    exact: true,
    component: BookCitationPageView,
  },
  {
    path: '/author/:authorSlug/:bookSlug/read/',
    exact: true,
    component: BookFragmentView,
  },
  {
    path: '/author/:authorSlug/:bookSlug/similar/',
    exact: true,
    component: SimilarBooksView,
  },
  {
    path: '/authors/',
    exact: true,
    component: AuthorListView,
  },
  {
    path: '/catalog/',
    exact: true,
    component: CatalogIndexView,
  },
  {
    path: '/catalog/books/',
    exact: true,
    component: CatalogBookListView,
  },
  {
    path: '/catalog/free/',
    exact: true,
    component: CatalogFreeIndexView,
  },
  {
    path: '/catalog/books/:bookType/',
    exact: true,
    component: CatalogBookListView,
  },
  {
    path: '/catalog/:nicheSlug/',
    exact: true,
    component: NicheDetailView,
  },
  {
    path: '/catalog/:nicheSlug/books/',
    exact: true,
    component: NicheBookListView,
  },
  {
    path: '/catalog/:nicheSlug/books/t/',
    exact: true,
    component: NicheBookListView,
  },
  {
    path: '/catalog/:nicheSlug/books/:bookType/',
    exact: true,
    component: NicheBookListView,
  },
  {
    path: '/catalog/:nicheSlug/books/:bookType/t/',
    exact: true,
    component: NicheBookListView,
  },
  {
    path: '/catalog/:nicheSlug/:genreSlug/',
    exact: true,
    component: GenreDetailView,
  },
  {
    path: '/catalog/:nicheSlug/:genreSlug/books/:bookType/',
    exact: true,
    component: GenreDetailView,
  },
  {
    path: '/catalog/:nicheSlug/:genreSlug/t/',
    exact: true,
    component: GenreDetailView,
  },
  {
    path: '/catalog/:nicheSlug/:genreSlug/books/:bookType/t/',
    exact: true,
    component: GenreDetailView,
  },
  {
    path: '/dashboard/',
    exact: true,
    component: DashboardView,
  },
  {
    path: '/offer/',
    exact: true,
    component: OfferView,
  },
  {
    path: '/payments/',
    exact: true,
    component: PaymentsView,
  },
  {
    path: '/payments/activate_gift/',
    exact: true,
    component: GiftCodeView,
  },
  {
    path: '/payments/rent_status/:paymentUuid/',
    exact: true,
    component: PaymentRentStatusView,
  },
  {
    path: '/payments/status/:paymentUuid/',
    exact: true,
    component: PaymentStatusView,
  },
  {
    path: '/profile/:userId/',
    exact: true,
    component: UserProfileView,
  },
  {
    path: '/profile/:userId/books/',
    exact: true,
    component: UserAllBooksView,
  },
  {
    path: '/profile/:userId/read/',
    exact: true,
    component: UserReadBooksView,
  },
  {
    path: '/profile/:userId/reading/',
    exact: true,
    component: UserReadingBooksView,
  },
  {
    path: '/profile/:userId/bookshelves/',
    exact: true,
    component: UserBookshelvesView,
  },
  {
    path: '/profile/:userId/bookmark/',
    exact: true,
    component: UserBookmarkView,
  },
  {
    path: '/profile/:userId/bookshelves/:bookshelfId/',
    exact: true,
    component: BookshelfDetailView,
  },
  {
    path: '/profile/:userId/editbookshelf/',
    exact: true,
    component: BookshelfEditView,
  },
  {
    path: '/profile/:userId/editbookshelf/:bookshelfId/',
    exact: true,
    component: BookshelfEditView,
  },
  {
    path: '/profile/:userId/wishlist/',
    exact: true,
    component: UserWishlistBooksView,
  },
  {
    path: '/profile/:userId/uploaded/',
    exact: true,
    component: UserUploadedBooksView,
  },
  {
    path: '/help/',
    exact: true,
    component: FaqIndexView,
  },
  {
    path: '/help/:sectionSlug/:questionSlug/',
    exact: true,
    component: FaqQuestionView,
  },
  {
    path: '/rightholder/:rightholderSlug/',
    exact: true,
    component: RightholderBooksView,
  },
  {
    path: '/search/',
    exact: true,
    component: SearchResultView,
  },
  {
    path: '/search/books/',
    exact: true,
    component: SearchBooksView,
  },
  {
    path: '/search/authors/',
    exact: true,
    component: SearchAuthorsView,
  },
  {
    path: '/search/series/',
    exact: true,
    component: SearchSeriesView,
  },
  {
    path: '/search/genres-themes/',
    exact: true,
    component: SearchGenresThemesView,
  },
  {
    path: '/search/booksets/',
    exact: true,
    component: SearchBooksetsView,
  },
  {
    path: '/search/audiobooks/',
    exact: true,
    component: SearchAudioBooksView,
  },
  {
    path: '/search/rightholders/',
    exact: true,
    component: SearchRightholdersView,
  },
  {
    path: '/book_choice/',
    exact: true,
    component: SearchByPreferencesView,
  },
  {
    path: '/series/:seriesSlug/',
    exact: true,
    component: SeriesDetailView,
  },
  {
    path: '/sets/',
    exact: true,
    component: BooksetListView,
  },
  {
    path: '/sets/:booksetId-:booksetSlug/',
    exact: true,
    component: BooksetDetailView,
  },
  {
    path: '/sets/:booksetId-:booksetSlug/t/',
    exact: true,
    component: BooksetDetailView,
  },
  {
    path: '/tags/',
    exact: true,
    component: TagListView,
  },
  {
    path: '/tags/:tagSlug/',
    exact: true,
    component: TagDetailView,
  },
  {
    path: '/trial/',
    exact: true,
    component: WeekTrialView,
  },
  {
    path: '*',
    component: Error404View,
  },
];

export default routes;
